function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.2 7.8L0 1C-.1.4.4-.1 1 0l6.8 1.1c.7.1 1 1 .5 1.4L2.6 8.3c-.5.5-1.3.2-1.4-.5zM22.8 16.2L24 23c.1.6-.4 1.1-1 1l-6.8-1.1c-.7-.1-1-1-.5-1.4l5.7-5.7c.5-.6 1.3-.3 1.4.4z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.3 4l17.8 17.9",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3 22.8c-.5 0-.9-.2-1.3-.5L3 5.3c-.7-.7-.7-1.8 0-2.5s1.8-.7 2.5 0l17 17c.7.7.7 1.8 0 2.5-.3.4-.8.5-1.2.5z",
  fill: "#231F20"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.8 7.8L24 1c.1-.6-.4-1.1-1-1l-6.8 1.1c-.7.1-1 1-.5 1.4l5.7 5.7c.5.6 1.3.3 1.4-.4zM1.2 16.2L0 23c-.1.6.4 1.1 1 1l6.8-1.1c.7-.1 1-1 .5-1.4l-5.7-5.7c-.5-.6-1.3-.3-1.4.4z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.7 4L1.9 21.9",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.8 22.7c-.5 0-.9-.2-1.3-.5-.7-.7-.7-1.8 0-2.5l17-16.9c.7-.7 1.8-.7 2.5 0s.7 1.8 0 2.5L4.1 22.2c-.3.3-.8.5-1.3.5z",
  fill: "#231F20"
}))));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default SvgComponent;